import { evenRound } from "./NumberUtils";

export const calculatePlatformFee = (totalAmount, feeType, feeFactor) => {

    switch (String(feeType)) {
		case 'FIXED':
			return feeFactor;
		case 'PERCENTAGE':
			let bFee = evenRound(parseFloat(totalAmount) * parseFloat(feeFactor)/100.00, 2);
			return bFee;
		case 'NO_FEE':
			return 0.00;
		case 'INVOICED':
			return 0.00;
		default:
			return null;
		}

}